import { inject, Injectable } from '@angular/core';
import { FormService } from '@jms/ui/ui.standalone.services/form.service';
import { Observable, of } from 'rxjs';
import { ContractorTenantSettingService } from './contractor.tenant.setting.service';

@Injectable()
export class OperationFormService extends FormService {

    private contractorTenantSettingService = inject(ContractorTenantSettingService);

    override getTenantUrl(): Observable<string> {
        const url = `https://${this.contractorTenantSettingService.tenantSettings.tenantUrl}`;
        return of(url);
    }
}